import React, { Component } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Steps } from 'primereact/steps';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { uniqueId } from 'lodash';
import filesize from 'filesize';
import { locale, addLocale } from 'primereact/api';

import { AuthContext } from '../main/ProvedorAutenticacao';
import Progresso from './Progresso';
import Upload from './Upload/Index';
import FileList from './FileList';

import GrupoTrabalhoService from '../app/service/GrupoTrabalhoService';
import UsuarioGrupoTrabalhoService from '../app/service/UsuarioGrupoTrabalhoService';
import ProcessoService from '../app/service/ProcessoService';
import AtividadeService from '../app/service/AtividadeService';
import ArquivoAtividadeService from '../app/service/ArquivoAtividadeService';
import TituloAtividadeService from '../app/service/TituloAtividadeService';
import CheckListAtividadeService from '../app/service/CheckListAtividadeService';
import ExecucaoCheckListService from '../app/service/ExecucaoCheckListService';
import PessoaService from '../app/service/PessoaService';

/**
 * Props:
 *   visible          {boolean}   - controla exibição
 *   dtLimiteInicial  {Date|null} - data pré-preenchida (Agenda); null = vazio (Navbar)
 *   onHide           {Function}  - chamado ao fechar sem salvar
 *   onCadastrado     {Function}  - chamado após salvar com sucesso
 */
class AtividadeInclusaoModal extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.itens    = [];
    this.formData = null;

    this.recorrenciaOpcoes = Array.from({ length: 23 }, (_, i) => ({
      codigo: String(i + 2),
      nome: String(i + 2),
    }));

    this.state = {
      carregando:   true,
      desabilitaBotao: false,
      classeDiv:    'hide',
      separador:    'none',

      // campos da atividade
      titulo:      '',
      descricao:   '',
      dtLimite:    '',
      dtFatal:     '',
      hora:        '',
      tipo:        '',
      grau:        [],
      recorrencia: null,

      // título predefinido
      tituloAtividade: null,
      titulos:         [],
      checkList:       [],

      // grupos
      grupos:        [],
      selectGrupo:   null,
      subGrupos:     [],
      selectSubGrupo: null,
      bloqueiaGrupo: false,

      // responsáveis / interessados
      responsaveis: [],
      responsavel:  null,
      interessados: [],
      interessado:  null,

      // processo
      pesquisaProcesso:        '',
      processoPesquisado:      '',
      processoPesquisadoVisivel: 'none',
      campoPesquisaProcesso:   'block',
      escondeBotalExcluirPesquisa: { display: 'none' },
      sizePesquisa:  'col-sm-12',
      processo:      null,
      processos:     [],
      partes:        [],
      displayProcesso: false,

      // pessoa
      pessoaPesquisa:         '',
      pessoaPesquisada:       '',
      pessoaPesquisadoVisivel: 'none',
      campoPesquisaPessoa:    'block',
      pessoa:    null,
      pessoas:   [],
      modalPessoas: false,

      // arquivos
      upLoadFiles: [],
      arquivos:    [],
      arquivo:     null,
      arquivoCodigo: '',
      dsArquivo:   '',
      modalDescricaoArquivo: false,
      fileData:    null,
      fileName:    '',
      modalExibirArquivo: false,
      displayAnexo: false,

      // modais auxiliares
      modalNovoTitulo:     false,
      novoTitulo:          '',
      pontuacao:           '',
      modalNovoGrupo:      false,
      novoGrupo:           '',
      novaDescricaoGrupo:  '',
    };

    this.grupoTrabalhoService        = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.processoService             = new ProcessoService();
    this.atividadeService            = new AtividadeService();
    this.arquivoAtividadeService     = new ArquivoAtividadeService();
    this.tituloAtividadeService      = new TituloAtividadeService();
    this.checkListAtividadeService   = new CheckListAtividadeService();
    this.execucaoCheckListService    = new ExecucaoCheckListService();
    this.pessoaService               = new PessoaService();

    this.acoesProcesso   = this.acoesProcesso.bind(this);
    this.acoesPessoa     = this.acoesPessoa.bind(this);
    this.acoesArquivos   = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.onGrauChange    = this.onGrauChange.bind(this);
    this.onChangeCheckList = this.onChangeCheckList.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
  }

  // ─── Ciclo de Vida ────────────────────────────────────────────────────────

  // O componente é remontado via key prop cada vez que o modal abre ou fecha.
  // Só inicializa quando visible=true (abertura).
  componentDidMount() {
    if (this.props.visible) {
      this.inicializar();
    }
  }

  inicializar = async () => {
    this.itens = [];
    this.formData = null;
    this.limparCampos();
    try {
      await Promise.all([
        this.consultarGruposTrabalho(),
        this.listarTitulos(),
        this.excluirArquivos(),
      ]);
      this.setState({ dtLimite: this.props.dtLimiteInicial || '' });
    } finally {
      this.setState({ carregando: false });
    }
  };

  limparCampos = () => {
    this.setState({
      titulo: '', descricao: '', dtLimite: '', dtFatal: '', hora: '',
      grau: [], recorrencia: null,
      tituloAtividade: null, checkList: [],
      selectGrupo: null, selectSubGrupo: null, subGrupos: [], bloqueiaGrupo: false,
      responsavel: null, responsaveis: [], interessado: null, interessados: [],
      pesquisaProcesso: '', processoPesquisado: '', processoPesquisadoVisivel: 'none',
      campoPesquisaProcesso: 'block', escondeBotalExcluirPesquisa: { display: 'none' },
      sizePesquisa: 'col-sm-12', processo: null, partes: [],
      pessoaPesquisa: '', pessoaPesquisada: '', pessoaPesquisadoVisivel: 'none',
      campoPesquisaPessoa: 'block', pessoa: null,
      upLoadFiles: [], arquivos: [],
      desabilitaBotao: false,
    });
  };

  // ─── Grupos ───────────────────────────────────────────────────────────────

  consultarGruposTrabalho = async () => {
    const { usuarioAutenticado } = this.context;
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioAutenticado.codigo)
      .then(r => this.setState({ grupos: r.data }))
      .catch(() => this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Erro ao carregar Grupos', life: 4000 }));
  };

  consultarSubGrupos = async () => {
    await this.grupoTrabalhoService.listarSubGrupos(this.state.selectGrupo.codigo)
      .then(r => this.setState({ subGrupos: r.data }))
      .catch(() => this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Erro ao carregar Sub-Grupos', life: 4000 }));
  };

  async onGrupoTrabalhoChange(e) {
    if (e.value) {
      await this.setState({ selectGrupo: e.value });
      this.consultarSubGrupos();
      this.listarResponsaveisAtivos();
      this.listarInteressadosAtivos();
    } else {
      this.setState({ selectGrupo: null, selectSubGrupo: null, subGrupos: [] });
    }
  }

  onSubGrupoChange(e) {
    this.setState({ selectSubGrupo: e.value });
  }

  listarResponsaveisAtivos = async () => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(r => this.setState({ responsaveis: r.data }))
      .catch(() => {});
  };

  listarInteressadosAtivos = async () => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(r => this.setState({ interessados: r.data }))
      .catch(() => {});
  };

  novoGrupoTrabalho = () => {
    this.setState({ novoGrupo: '', novaDescricaoGrupo: '', modalNovoGrupo: true });
  };

  cadastrarGrupoTrabalho = async () => {
    const { usuarioAutenticado } = this.context;
    if (!this.state.novoGrupo) {
      this.toast.show({ severity: 'error', summary: 'Grupos', detail: 'Informe o nome do Grupo', life: 4000 });
      return;
    }
    this.setState({ openSpinner: true });
    await this.grupoTrabalhoService.cadastrarGrupo({
      nome: this.state.novoGrupo,
      descrica: this.state.novaDescricaoGrupo,
      empresa: usuarioAutenticado.empresa,
    }).then(() => {
      this.consultarGruposTrabalho();
      this.setState({ modalNovoGrupo: false, openSpinner: false });
      this.toast.show({ severity: 'success', summary: 'Grupos', detail: 'Grupo cadastrado com sucesso', life: 4000 });
    }).catch(() => {
      this.setState({ openSpinner: false });
      this.toast.show({ severity: 'error', summary: 'Grupos', detail: 'Erro ao cadastrar Grupo', life: 4000 });
    });
  };

  // ─── Títulos ──────────────────────────────────────────────────────────────

  listarTitulos = async () => {
    const { usuarioAutenticado } = this.context;
    await this.tituloAtividadeService.listar(usuarioAutenticado.empresa.codigo)
      .then(r => this.setState({ titulos: r.data }))
      .catch(() => {});
  };

  onChangeCheckList(e) {
    if (e.value) {
      this.itens = [];
      this.setState({ tituloAtividade: e.value });
      this.consultarCheckList(e.value.codigo);
    } else {
      this.itens = [];
      this.setState({ tituloAtividade: null });
    }
  }

  consultarCheckList = async (atividade) => {
    this.setState({ openSpinner: true });
    await this.checkListAtividadeService.listar(atividade)
      .then(r => {
        this.setState({ checkList: r.data });
        this.itens = r.data.map(c => ({ label: c.tarefa }));
      }).catch(() => {});
    this.setState({ openSpinner: false });
  };

  novoTituloAtividade = async () => {
    this.setState({ novoTitulo: '', pontuacao: '', openSpinner: true });
    this.setState({ openSpinner: false, modalNovoTitulo: true });
  };

  cadastrarNovoTitulo = async () => {
    const { usuarioAutenticado } = this.context;
    if (!this.state.novoTitulo) {
      this.toast.show({ severity: 'error', summary: 'Títulos', detail: 'Informe o título', life: 4000 });
      return;
    }
    if (!this.state.pontuacao) {
      this.toast.show({ severity: 'error', summary: 'Títulos', detail: 'Informe a pontuação', life: 4000 });
      return;
    }
    this.setState({ openSpinner: true });
    await this.tituloAtividadeService.cadastrar({
      titulo: this.state.novoTitulo,
      pontos: this.state.pontuacao,
      empresa: usuarioAutenticado.empresa,
    }).then(() => {
      this.listarTitulos();
      this.setState({ modalNovoTitulo: false, openSpinner: false });
      this.toast.show({ severity: 'success', summary: 'Títulos', detail: 'Título cadastrado com sucesso', life: 4000 });
    }).catch(() => {
      this.setState({ openSpinner: false });
      this.toast.show({ severity: 'error', summary: 'Títulos', detail: 'Erro ao cadastrar título', life: 4000 });
    });
  };

  // ─── Processo ─────────────────────────────────────────────────────────────

  consultarProcessoPorIndice = async () => {
    const { usuarioAutenticado } = this.context;
    this.setState({ classeDiv: 'show', separador: 'block', desabilitaBotao: true });
    await this.processoService.consultarProcessoPorIndice({
      indice: this.state.pesquisaProcesso,
      empresa: usuarioAutenticado.empresa.codigo,
      usuario: usuarioAutenticado.codigo,
    }).then(r => {
      this.setState({ processos: r.data });
      if (r.data.length > 0) {
        this.setState({ displayProcesso: true });
      } else {
        this.setState({ pesquisaProcesso: '' });
        this.toast.show({ severity: 'error', summary: 'Processos', detail: 'Processo não encontrado', life: 4000 });
      }
    }).catch(() => {
      this.toast.show({ severity: 'error', summary: 'Processos', detail: 'Erro ao buscar processo', life: 4000 });
    });
    this.setState({ classeDiv: 'hide', separador: 'none', desabilitaBotao: false });
  };

  selecionarProcesso = async (processo) => {
    const { usuarioAutenticado } = this.context;
    this.setState({ classeDiv: 'show', separador: 'block' });
    await this.processoService.consultarProcessoPorCodigo(processo.codigo, usuarioAutenticado.codigo)
      .then(r => {
        const p = r.data;
        this.setState({
          processo: p,
          partes: p.partes || [],
          pesquisaProcesso: p.nrCnj || p.nrProcesso,
          selectGrupo: p.grupoTrabalho,
          bloqueiaGrupo: true,
          campoPesquisaProcesso: 'none',
          processoPesquisadoVisivel: 'block',
          escondeBotalExcluirPesquisa: { display: 'block' },
          displayProcesso: false,
        });

        let textoProcesso = p.nrCnj ? this.formatarCnj(p.nrCnj) : p.nrProcesso;
        this.setState({ processoPesquisado: textoProcesso });

        this.consultarSubGrupos();
        this.listarResponsaveisAtivos();
        this.listarInteressadosAtivos();
      }).catch(() => {
        this.toast.show({ severity: 'error', summary: 'Processos', detail: 'Erro ao consultar processo', life: 4000 });
      });
    this.setState({ classeDiv: 'hide', separador: 'none' });
  };

  formatarCnj = (cnj) => {
    return `${cnj.substring(0,7)}-${cnj.substring(7,9)}.${cnj.substring(9,13)}.${cnj.substring(13,14)}.${cnj.substring(14,16)}.${cnj.substring(16,20)}`;
  };

  excluirPesquisaProcesso = () => {
    this.setState({
      processo: null, partes: [], pesquisaProcesso: '', processoPesquisado: '',
      processoPesquisadoVisivel: 'none', campoPesquisaProcesso: 'block',
      escondeBotalExcluirPesquisa: { display: 'none' }, sizePesquisa: 'col-sm-12',
      bloqueiaGrupo: false, selectGrupo: null, subGrupos: [], selectSubGrupo: null,
      interessado: null, responsavel: null, responsaveis: [],
    });
  };

  acoesProcesso(rowData) {
    return (
      <Button icon="pi pi-check" className="p-button-rounded p-button-text"
        tooltip="Selecionar" tooltipOptions={{ position: 'top' }}
        onClick={() => this.selecionarProcesso(rowData)} />
    );
  }

  // ─── Pessoa ───────────────────────────────────────────────────────────────

  consultarPessoasPorNomeOuCpf = async () => {
    if (!this.state.pessoaPesquisa) return;
    const { usuarioAutenticado } = this.context;
    this.setState({ classeDiv: 'show', separador: 'block' });
    await this.pessoaService.consultarPorNomeOuCpf(usuarioAutenticado.empresa.codigo, this.state.pessoaPesquisa)
      .then(r => {
        this.setState({ pessoas: r.data, modalPessoas: true });
      }).catch(() => {
        this.toast.show({ severity: 'error', summary: 'Pessoas', detail: 'Erro ao buscar pessoa', life: 4000 });
      });
    this.setState({ classeDiv: 'hide', separador: 'none' });
  };

  selecionarPessoa = async (pessoa) => {
    this.setState({ openSpinner: true });
    await this.pessoaService.consultarPessoa(pessoa.codigo)
      .then(r => {
        this.setState({
          pessoa: r.data,
          pessoaPesquisada: r.data.nome,
          campoPesquisaPessoa: 'none',
          pessoaPesquisadoVisivel: 'block',
          modalPessoas: false,
        });
      }).catch(() => {
        this.toast.show({ severity: 'error', summary: 'Pessoas', detail: 'Erro ao consultar pessoa', life: 4000 });
      });
    this.setState({ openSpinner: false });
  };

  excluirPesquisaPessoa = () => {
    this.setState({
      pessoa: null, pessoaPesquisada: '', pessoaPesquisa: '',
      campoPesquisaPessoa: 'block', pessoaPesquisadoVisivel: 'none',
    });
  };

  acoesPessoa(rowData) {
    return (
      <Button icon="pi pi-check" className="p-button-rounded p-button-text"
        tooltip="Selecionar" tooltipOptions={{ position: 'top' }}
        onClick={() => this.selecionarPessoa(rowData)} />
    );
  }

  // ─── Grau ─────────────────────────────────────────────────────────────────

  onGrauChange(e) {
    const grau = [...this.state.grau];
    if (e.checked) grau.push(e.value);
    else grau.splice(grau.indexOf(e.value), 1);
    this.setState({ grau });
  }

  // ─── Arquivos ─────────────────────────────────────────────────────────────

  excluirArquivos = async () => {
    const { usuarioAutenticado } = this.context;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioAutenticado.codigo).catch(() => {});
  };

  handleUpload = async (files) => {
    const novos = files.map(file => ({
      file, id: uniqueId(), name: file.name,
      readableSize: filesize(file.size), progress: 0,
      uploaded: false, error: false, url: file.url,
    }));
    this.setState({ upLoadFiles: this.state.upLoadFiles.concat(novos) });
    await novos.forEach(this.processarArquivo);
  };

  processarArquivo = async (upLoadFile) => {
    const { usuarioAutenticado } = this.context;
    const data = new FormData();
    data.append('file', upLoadFile.file);
    data.append('usuario', upLoadFile.file, usuarioAutenticado.codigo);
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(() => {
        this.handleDeleteFile(upLoadFile.id);
        this.listarArquivosTemp();
      }).catch(() => {
        this.toast.show({ severity: 'error', summary: 'Arquivos', detail: 'Erro ao enviar arquivo', life: 4000 });
      });
  };

  listarArquivosTemp = async () => {
    const { usuarioAutenticado } = this.context;
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioAutenticado.codigo)
      .then(r => this.setState({ arquivos: r.data }))
      .catch(() => {});
  };

  handleDeleteFile = (id) => {
    this.setState({ upLoadFiles: this.state.upLoadFiles.filter(f => f.id !== id) });
  };

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivoTemp(this.state.arquivoCodigo)
      .then(() => {
        this.toast.show({ severity: 'success', summary: 'Arquivos', detail: 'Arquivo excluído', life: 4000 });
        this.listarArquivosTemp();
      }).catch(() => {});
  };

  acceptExcluirArquivo() { this.excluirArquivo(); }

  confirmaExclusaoArquivo = (arquivo) => {
    this.setState({ arquivoCodigo: arquivo.codigo });
    confirmDialog({
      message: 'Deseja realmente excluir este arquivo?',
      header: 'Exclusão de Arquivo',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Sim', rejectLabel: 'Não',
      accept: this.acceptExcluirArquivo,
    });
  };

  consultarArquivoDescricao = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(r => this.setState({ arquivo: r.data, dsArquivo: r.data.descricao }))
      .catch(() => {});
    this.setState({ modalDescricaoArquivo: true });
  };

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.dsArquivo,
    }).then(() => {
      this.toast.show({ severity: 'success', summary: 'Arquivos', detail: 'Descrição adicionada', life: 4000 });
      this.listarArquivosTemp();
    }).catch(() => {});
    this.setState({ modalDescricaoArquivo: false });
  };

  download = async (rowData) => {
    await this.arquivoAtividadeService.consultarArquivoTemp(rowData.codigo)
      .then(r => this.setState({ arquivo: r.data })).catch(() => {});
    await this.arquivoAtividadeService.downloadTemp(rowData.codigo)
      .then(r => {
        const url  = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement('a');
        link.href  = url;
        link.setAttribute('download', this.state.arquivo.arquivo);
        document.body.appendChild(link);
        link.click();
      }).catch(() => {});
  };

  exibirArquivo = async (arquivo) => {
    const { usuarioAutenticado } = this.context;
    this.setState({ openSpinner: true });
    await this.arquivoAtividadeService.exibirArquivoTemp(arquivo.arquivo, usuarioAutenticado.codigo)
      .then(r => {
        this.setState({
          fileData: URL.createObjectURL(r.data),
          fileName: arquivo.arquivo,
          modalExibirArquivo: true,
        });
      }).catch(() => {});
    this.setState({ openSpinner: false });
  };

  acoesArquivos(rowData) {
    return (
      <>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text" tooltip="Visualizar"
          tooltipOptions={{ position: 'top' }} style={{ width: 20, height: 10 }}
          onClick={() => this.exibirArquivo(rowData)} />
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text" tooltip="Descrição"
          tooltipOptions={{ position: 'top' }} style={{ width: 20, height: 10 }}
          onClick={() => this.consultarArquivoDescricao(rowData)} />
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text" tooltip="Baixar"
          tooltipOptions={{ position: 'top' }} style={{ width: 20, height: 10 }}
          onClick={() => this.download(rowData)} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text" tooltip="Excluir"
          tooltipOptions={{ position: 'top' }} style={{ width: 20, height: 10 }}
          onClick={() => this.confirmaExclusaoArquivo(rowData)} />
      </>
    );
  }

  // ─── Cadastrar ────────────────────────────────────────────────────────────

  pad2 = n => (n < 10 ? '0' : '') + n;

  formatarData = (date, hora) => {
    if (!date) return '';
    const m = this.pad2(date.getMonth() + 1);
    const d = this.pad2(date.getDate());
    const y = date.getFullYear();
    return hora ? `${y}-${m}-${d} ${hora}:00` : `${y}-${m}-${d}`;
  };

  cadastrarAtividade = async () => {
    const { usuarioAutenticado } = this.context;
    const s = this.state;

    if (!s.tituloAtividade) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Informe o título da Atividade', life: 4000 });
      return;
    }
    if (!s.selectGrupo) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Informe o Grupo de Trabalho', life: 4000 });
      return;
    }
    if (!s.selectSubGrupo) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Informe o Sub-Grupo de Trabalho', life: 4000 });
      return;
    }
    if (!s.responsavel) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Informe ao menos um responsável', life: 4000 });
      return;
    }
    if (!s.dtLimite) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Informe a Data Limite', life: 4000 });
      return;
    }
    if (s.pesquisaProcesso && !s.processo) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Pesquise e selecione o processo informado', life: 9000 });
      return;
    }
    if (s.pessoaPesquisa && !s.pessoa) {
      this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Pesquise e selecione a pessoa informada', life: 9000 });
      return;
    }

    const dtLimiteFormatada = this.formatarData(s.dtLimite, s.hora);
    const tipoTarefa        = s.hora ? 'A' : 'T';
    const dtFatalFormatada  = s.dtFatal ? this.formatarData(s.dtFatal, s.hora) : null;

    const grauMap = { importante: 'N', urgente: 'N', privado: 'N' };
    s.grau.forEach(g => { grauMap[g] = 'S'; });

    const cadastro = {
      atividade: {
        titulo: s.tituloAtividade.titulo,
        processo: s.processo ? { codigo: s.processo.codigo } : null,
        subGrupo: s.selectSubGrupo,
        dtLimite: dtLimiteFormatada,
        dtFatal:  dtFatalFormatada,
        descricao: s.descricao,
        usuario:  usuarioAutenticado,
        tipo:     tipoTarefa,
        status:   { codigo: 1 },
        importante: grauMap.importante,
        urgente:    grauMap.urgente,
        privado:    grauMap.privado,
        pessoa:     s.pessoa,
        tituloAtividade: s.tituloAtividade,
        lancamentoFinanceiro: null,
      },
      responsaveis: s.responsavel,
      interessados: s.interessado,
      arquivos:     this.formData,
      recorrencia:  s.recorrencia ? s.recorrencia.codigo : '0',
      responsaveisSubTarefas: null,
      interessadosSubTarefas: null,
      empresaId: usuarioAutenticado.empresa.codigo,
    };

    this.setState({ desabilitaBotao: true, classeDiv: 'show', separador: 'block' });
    await this.atividadeService.cadastrarAtividade(cadastro)
      .then(r => {
        this.cadastrarExecucaoCheckList(r.data);
        this.toast.show({ severity: 'success', summary: 'Atividades', detail: 'Atividade cadastrada com sucesso', life: 4000 });
        this.setState({ classeDiv: 'hide', separador: 'none', desabilitaBotao: false });
        this.props.onCadastrado();
      }).catch(() => {
        this.setState({ classeDiv: 'hide', separador: 'none', desabilitaBotao: false });
        this.toast.show({ severity: 'error', summary: 'Atividades', detail: 'Erro ao cadastrar atividade', life: 4000 });
      });
  };

  cadastrarExecucaoCheckList = async (atividade) => {
    await this.execucaoCheckListService.cadastrar({
      atividade,
      checkList: this.state.checkList,
    }).catch(() => {});
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  render() {
    const { usuarioAutenticado } = this.context;
    const { visible, onHide }    = this.props;
    const { upLoadFiles }        = this.state;
    const perfil = usuarioAutenticado.perfil.codigo;
    const mostraCriaGrupo  = (perfil === 1 || perfil === 2) ? 'block' : 'none';
    const mostraCriaTitulo = (perfil === 1 || perfil === 2) ? 'block' : 'none';
    const mostraRecorrencia = usuarioAutenticado.empresa.codigo === 151;

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'],
      dayNamesShort: ['dom','seg','ter','qua','qui','sex','sáb'],
      dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],
      monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
      monthNamesShort: ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'],
      today: 'Hoje', clear: 'Limpar',
    });
    locale('es');

    const footerPrincipal = (
      <div className="left">
        <Button label="Cadastrar" disabled={this.state.desabilitaBotao}
          className="p-button-primary p-button-text" onClick={this.cadastrarAtividade} />
        &nbsp;
        <Button label="Anexar" disabled={this.state.desabilitaBotao}
          icon="pi pi-paperclip" className="p-button-help p-button-text"
          onClick={() => this.setState({ displayAnexo: true })} />
        &nbsp;
        <Button label="Cancelar" disabled={this.state.desabilitaBotao}
          className="p-button-secondary p-button-text" onClick={onHide} />
      </div>
    );

    return (
      <>
        <Toast ref={el => this.toast = el} />
        <ConfirmDialog />

        {/* ── Dialog Principal ────────────────────────── */}
        <Dialog header="Incluir Atividade" visible={visible}
          style={{ width: '48vw' }} footer={footerPrincipal} onHide={onHide}>

          <Progresso classeSecundaria={this.state.classeDiv} />
          {this.state.separador === 'block' && (
            <div><br /><strong style={{ color: '#343A40' }}>Aguarde....</strong><br /><br /></div>
          )}

          {/* Pessoa */}
          <div className="row">
            <div className={this.state.sizePesquisa}>
              <div className="form-group" style={{ display: this.state.campoPesquisaPessoa }}>
                <InputText style={{ width: '100%', height: '32px' }} autoComplete="off"
                  value={this.state.pessoaPesquisa} placeholder="Pesquise a pessoa por nome ou CPF"
                  onChange={e => this.setState({ pessoaPesquisa: e.target.value })}
                  onKeyPress={e => e.key === 'Enter' && this.consultarPessoasPorNomeOuCpf()}
                  className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
              <div className="form-group" style={{ display: this.state.pessoaPesquisadoVisivel }}>
                <strong>Pessoa: {this.state.pessoaPesquisada}</strong><br />
                <a onClick={this.excluirPesquisaPessoa} className="linkCadGrupo" style={{ cursor: 'pointer' }}>Desvincular Pessoa</a>
              </div>
            </div>
          </div>

          {/* Processo */}
          <div className="row">
            <div className={this.state.sizePesquisa}>
              <div className="form-group" style={{ display: this.state.campoPesquisaProcesso }}>
                <InputText style={{ width: '100%', height: '32px' }} autoComplete="off"
                  disabled={this.state.bloqueiaGrupo} value={this.state.pesquisaProcesso}
                  placeholder="Pesquise o processo por pasta, partes ou numeração"
                  onChange={e => this.setState({ pesquisaProcesso: e.target.value })}
                  onKeyPress={e => e.key === 'Enter' && this.consultarProcessoPorIndice()}
                  className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
              <div className="form-group" style={{ display: this.state.processoPesquisadoVisivel }}>
                <strong>Processo: {this.state.processoPesquisado}</strong><br />
                <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{ cursor: 'pointer' }}>Desvincular Processo</a>
              </div>
              {this.state.partes?.length > 0 && (
                <>
                  <label><strong>Partes:</strong></label>
                  <table className="table table-sm table-bordered mt-2">
                    <tbody>
                      {this.state.partes.map((parte, i) => (
                        <tr key={i}>
                          <td>{parte.pessoa.nome} &nbsp;-&nbsp; {parte.pessoa.cpf} &nbsp;-&nbsp; {parte.nomeTipo}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>

          {/* Título */}
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <Dropdown value={this.state.tituloAtividade} options={this.state.titulos}
                  optionLabel="tituloExibir" filter showClear filterBy="tituloExibir"
                  emptyMessage=" " onChange={this.onChangeCheckList}
                  style={{ width: '100%', height: '32px' }}
                  className="p-inputtext-sm p-d-block p-mb-1" placeholder="Título de Atividade" />
                <a className="linkCadGrupo" onClick={this.novoTituloAtividade}
                  style={{ cursor: 'pointer', display: mostraCriaTitulo }}>
                  Caso o título ainda não exista, crie clicando Aqui
                </a>
              </div>
            </div>
          </div>

          {/* Checklist Steps */}
          {this.itens.length > 0 && (
            <div className="row">
              <div className="col-sm-12">
                <Steps model={this.itens} activeIndex={-1} readOnly={false} />
              </div>
            </div>
          )}

          {/* Grupo / Sub-Grupo */}
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <Dropdown value={this.state.selectGrupo} options={this.state.grupos}
                  optionLabel="nome" filter showClear filterBy="nome"
                  disabled={this.state.bloqueiaGrupo} onChange={this.onGrupoTrabalhoChange}
                  style={{ width: '100%', height: '32px' }}
                  className="p-inputtext-sm p-d-block p-mb-1" placeholder="Grupo de Trabalho" />
                <a onClick={this.novoGrupoTrabalho}
                  style={{ display: mostraCriaGrupo, cursor: 'pointer' }} className="linkCadGrupo">
                  Caso o grupo ainda não exista, crie clicando Aqui
                </a>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <Dropdown value={this.state.selectSubGrupo} options={this.state.subGrupos}
                  optionLabel="nome" filter showClear filterBy="nome" emptyMessage=" "
                  onChange={this.onSubGrupoChange}
                  style={{ width: '100%', height: '32px' }}
                  className="p-inputtext-sm p-d-block p-mb-1" placeholder="Sub-Grupo de Trabalho" />
              </div>
            </div>
          </div>

          {/* Responsáveis / Interessados */}
          <div className="row">
            <div className="col-sm-6">
              <MultiSelect value={this.state.responsavel} options={this.state.responsaveis}
                style={{ width: '100%', height: '32px' }} filter showClear filterBy="nome"
                optionLabel="nome" placeholder="Responsáveis"
                onChange={e => this.setState({ responsavel: e.value })} />
            </div>
            <div className="col-sm-6">
              <MultiSelect value={this.state.interessado} options={this.state.interessados}
                style={{ width: '100%', height: '32px' }} filter showClear filterBy="nome"
                optionLabel="nome" placeholder="Interessados"
                onChange={e => this.setState({ interessado: e.value })} />
            </div>
          </div>

          {/* Recorrência (empresa específica) */}
          {mostraRecorrencia && (
            <div className="row mt-2">
              <div className="col-sm-12">
                <Dropdown value={this.state.recorrencia} options={this.recorrenciaOpcoes}
                  optionLabel="nome" emptyMessage=" " filter showClear filterBy="nome"
                  onChange={e => this.setState({ recorrencia: e.value })}
                  style={{ width: '100%', height: '32px' }}
                  className="p-inputtext-sm p-d-block p-mb-1" placeholder="Recorrência ?" />
              </div>
            </div>
          )}

          {/* Datas */}
          <div className="row mt-2">
            <div className="col-sm-3">
              <Calendar value={this.state.dtLimite}
                onChange={e => this.setState({ dtLimite: e.value })}
                locale="es" dateFormat="dd/mm/yy" mask="99/99/9999"
                style={{ width: '100%', height: '32px' }} placeholder="Data Limite" />
            </div>
            <div className="col-sm-3">
              <InputMask mask="99:99" value={this.state.hora}
                onChange={e => this.setState({ hora: e.target.value })}
                style={{ width: '100%', height: '32px' }}
                className="p-inputtext-sm p-d-block p-mb-1" placeholder="Hora" />
            </div>
            <div className="col-sm-6">
              <Calendar value={this.state.dtFatal}
                onChange={e => this.setState({ dtFatal: e.value })}
                locale="es" dateFormat="dd/mm/yy" mask="99/99/9999"
                style={{ width: '100%', height: '32px' }} placeholder="Prazo Fatal" />
            </div>
          </div>

          {/* Descrição */}
          <div className="row mt-2">
            <div className="col-sm-12">
              <InputTextarea value={this.state.descricao} rows={3} cols={30}
                style={{ width: '100%' }} placeholder="Descrição da Atividade"
                onChange={e => this.setState({ descricao: e.target.value })}
                className="p-inputtext-sm p-d-block p-mb-1" />
            </div>
          </div>

          {/* Grau */}
          <div className="row mt-2" style={{ marginLeft: '4px' }}>
            <label>
              <Checkbox inputId="importante" name="importante" value="importante"
                onChange={this.onGrauChange} checked={this.state.grau.indexOf('importante') !== -1} />
              &nbsp;&nbsp;Importante&nbsp;&nbsp;
              <Checkbox inputId="urgente" name="urgente" value="urgente"
                onChange={this.onGrauChange} checked={this.state.grau.indexOf('urgente') !== -1} />
              &nbsp;&nbsp;Urgente&nbsp;&nbsp;
              <Checkbox inputId="privado" name="privado" value="privado"
                onChange={this.onGrauChange} checked={this.state.grau.indexOf('privado') !== -1} />
              &nbsp;&nbsp;Privado
            </label>
          </div>
        </Dialog>

        {/* ── Busca de Processo ───────────────────────── */}
        <Dialog header="Busca de Processo" visible={this.state.displayProcesso}
          style={{ width: '60vw' }} onHide={() => this.setState({ displayProcesso: false })}
          footer={<Button label="Fechar" className="p-button-secondary p-button-text"
            onClick={() => this.setState({ displayProcesso: false })} />}>
          <Progresso classeSecundaria={this.state.classeDiv} />
          <DataTable value={this.state.processos} alwaysShowPaginator rows={4} emptyMessage=" "
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            tableStyle={{ minWidth: '40rem' }}>
            <Column field="pasta" header="Pasta" />
            <Column field="nrProcesso" header="Processo Original" />
            <Column field="nrCnj" header="Numeração Única" />
            <Column field="autor" header="Autor x Réu" style={{ width: '250px' }} />
            <Column field="grupoTrabalho.nome" header="Grupo" />
            <Column body={this.acoesProcesso} style={{ minWidth: '6rem' }} header="Ações" />
          </DataTable>
        </Dialog>

        {/* ── Busca de Pessoas ────────────────────────── */}
        <Dialog header="Busca de Pessoas" visible={this.state.modalPessoas}
          style={{ width: '55vw' }} onHide={() => this.setState({ modalPessoas: false })}
          footer={<Button label="Fechar" className="p-button-secondary p-button-text"
            onClick={() => this.setState({ modalPessoas: false })} />}>
          <Progresso classeSecundaria={this.state.classeDiv} />
          <DataTable value={this.state.pessoas} alwaysShowPaginator rows={4} emptyMessage=" "
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            tableStyle={{ minWidth: '35rem' }}>
            <Column field="nome" header="Pessoa" />
            <Column field="cpfCnpj" header="CPF/CNPJ" />
            <Column field="tipoPessoa" header="Tipo" />
            <Column body={this.acoesPessoa} style={{ minWidth: '6rem' }} header="Ações" />
          </DataTable>
        </Dialog>

        {/* ── Anexar Documentos ───────────────────────── */}
        <Dialog header="Anexar Documentos" visible={this.state.displayAnexo}
          style={{ width: '40vw' }} onHide={() => this.setState({ displayAnexo: false })}
          footer={<Button label="Fechar" className="p-button-secondary p-button-text"
            onClick={() => this.setState({ displayAnexo: false })} />}>
          <div className="container">
            <Upload onUpload={this.handleUpload} />
            {!!upLoadFiles?.length && <FileList files={upLoadFiles} onDelete={this.handleDeleteFile} />}
          </div>
          <DataTable value={this.state.arquivos} size="small" emptyMessage="Nenhum arquivo"
            tableStyle={{ minWidth: '25rem' }}>
            <Column field="arquivo" header="Arquivo" />
            <Column field="descricao" header="Descrição" />
            <Column body={this.acoesArquivos} style={{ minWidth: '8rem' }} header="Ações" />
          </DataTable>
        </Dialog>

        {/* ── Descrição do Arquivo ────────────────────── */}
        <Dialog header="Descrição do Arquivo" visible={this.state.modalDescricaoArquivo}
          style={{ width: '35vw' }} onHide={() => this.setState({ modalDescricaoArquivo: false })}
          footer={
            <>
              <Button label="Cancelar" className="p-button-secondary p-button-text"
                onClick={() => this.setState({ modalDescricaoArquivo: false })} />
              &nbsp;
              <Button label="Salvar" className="p-button-primary p-button-text"
                onClick={this.adicionarDescricao} />
            </>
          }>
          <InputText style={{ width: '100%', height: '37px' }} value={this.state.dsArquivo}
            onChange={e => this.setState({ dsArquivo: e.target.value })}
            className="p-inputtext-sm p-d-block p-mb-1" />
        </Dialog>

        {/* ── Visualizar Arquivo ──────────────────────── */}
        <Dialog header="Arquivo" visible={this.state.modalExibirArquivo}
          style={{ width: '60vw' }} onHide={() => this.setState({ modalExibirArquivo: false })}
          footer={<Button label="Fechar" className="p-button-secondary p-button-text"
            onClick={() => this.setState({ modalExibirArquivo: false })} />}>
          {this.state.fileData && (
            this.state.fileName?.toLowerCase().endsWith('.pdf') ? (
              <iframe src={this.state.fileData} title="PDF" style={{ width: '100%', height: '500px', border: '1px solid #ddd' }} />
            ) : (
              <img src={this.state.fileData} alt={this.state.fileName} style={{ maxWidth: '100%', maxHeight: '500px' }} />
            )
          )}
        </Dialog>

        {/* ── Novo Título ─────────────────────────────── */}
        <Dialog header="Incluir Novo Título de Atividade" visible={this.state.modalNovoTitulo}
          style={{ width: '40vw' }} onHide={() => this.setState({ modalNovoTitulo: false })}
          footer={
            <>
              <Button label="Cadastrar" className="p-button-primary p-button-text" onClick={this.cadastrarNovoTitulo} />
              &nbsp;
              <Button label="Cancelar" className="p-button-secondary p-button-text"
                onClick={() => this.setState({ modalNovoTitulo: false })} />
            </>
          }>
          <div className="row">
            <div className="col-sm-12 mb-2">
              <InputText style={{ width: '100%', height: '32px' }} value={this.state.novoTitulo}
                placeholder="Título da Atividade" onChange={e => this.setState({ novoTitulo: e.target.value })}
                className="p-inputtext-sm" />
            </div>
            <div className="col-sm-12 mb-2">
              <InputText style={{ width: '100%', height: '32px' }} value={this.state.pontuacao}
                placeholder="Pontuação" onChange={e => this.setState({ pontuacao: e.target.value })}
                className="p-inputtext-sm" />
            </div>
          </div>
        </Dialog>

        {/* ── Spinner de carregamento inicial ─────────── */}
        {this.props.visible && this.state.carregando && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 99999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div className="spinner-border text-light" style={{ width: '4rem', height: '4rem' }} role="status" />
          </div>
        )}

        {/* ── Novo Grupo ──────────────────────────────── */}
        <Dialog header="Incluir Novo Grupo de Trabalho" visible={this.state.modalNovoGrupo}
          style={{ width: '40vw' }} onHide={() => this.setState({ modalNovoGrupo: false })}
          footer={
            <>
              <Button label="Cadastrar" className="p-button-primary p-button-text" onClick={this.cadastrarGrupoTrabalho} />
              &nbsp;
              <Button label="Cancelar" className="p-button-secondary p-button-text"
                onClick={() => this.setState({ modalNovoGrupo: false })} />
            </>
          }>
          <div className="row">
            <div className="col-sm-12 mb-2">
              <InputText style={{ width: '100%', height: '32px' }} value={this.state.novoGrupo}
                placeholder="Grupo de Trabalho" onChange={e => this.setState({ novoGrupo: e.target.value })}
                className="p-inputtext-sm" />
            </div>
            <div className="col-sm-12">
              <InputText style={{ width: '100%', height: '32px' }} value={this.state.novaDescricaoGrupo}
                placeholder="Descrição" onChange={e => this.setState({ novaDescricaoGrupo: e.target.value })}
                className="p-inputtext-sm" />
            </div>
          </div>
        </Dialog>

      </>
    );
  }
}

export default AtividadeInclusaoModal;
